import { render, staticRenderFns } from "./MultipleChoicePublicDisplayItem.vue?vue&type=template&id=4d501665&scoped=true"
import script from "./MultipleChoicePublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./MultipleChoicePublicDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoicePublicDisplayItem.vue?vue&type=style&index=0&id=4d501665&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d501665",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d501665')) {
      api.createRecord('4d501665', component.options)
    } else {
      api.reload('4d501665', component.options)
    }
    module.hot.accept("./MultipleChoicePublicDisplayItem.vue?vue&type=template&id=4d501665&scoped=true", function () {
      api.rerender('4d501665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/MultipleChoicePublicDisplayItem.vue"
export default component.exports